
import React from "react";
import { Routes, Route } from "react-router-dom";
import Index from "@/pages/Index";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ResetPassword from "@/pages/ResetPassword";
import UpdatePassword from "@/pages/UpdatePassword";
import CompleteProfile from "@/pages/CompleteProfile";
import Dashboard from "@/pages/Dashboard";
import Campaigns from "@/pages/Campaigns";
import Customers from "@/pages/Customers";
import Cashback from "@/pages/Cashback";
import Referrals from "@/pages/Referrals";
import Integrations from "@/pages/Integrations";
import ContentLibrary from "@/pages/ContentLibrary";
import Settings from "@/pages/Settings";
import WebhookSettings from "@/pages/WebhookSettings";
import WebhookDebug from "@/pages/WebhookDebug";
import Plans from "@/pages/Plans";
import NotFound from "@/pages/NotFound";
import NuvemshopCallback from "@/pages/NuvemshopCallback";
import NuvemshopCallbackNew from "@/pages/nuvemshop-callback";
import TestCallback from "@/pages/TestCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import ProfileCompletionCheck from "@/components/ProfileCompletionCheck";
import ScheduledCoupons from "@/pages/ScheduledCoupons";
import Layout from "@/components/Layout";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/update-password" element={<UpdatePassword />} />
      <Route path="/complete-profile" element={<CompleteProfile />} />
      
      {/* OAuth Callback Routes - MUST come before protected routes */}
      <Route path="/nuvemshop-callback" element={<NuvemshopCallbackNew />} />
      <Route path="/nuvemshop/callback" element={<NuvemshopCallback />} />
      <Route path="/test-callback" element={<TestCallback />} />
      
      {/* Protected Routes with Layout */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <Dashboard />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/campaigns" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <Campaigns />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/scheduled-coupons" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <ScheduledCoupons />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/customers" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <Customers />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/cashback" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <Cashback />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/referrals" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <Referrals />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/integrations" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <Integrations />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/content-library" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <ContentLibrary />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <Settings />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings/webhooks" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <WebhookSettings />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/webhook-debug" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <WebhookDebug />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/plans" 
        element={
          <ProtectedRoute>
            <ProfileCompletionCheck>
              <Layout>
                <Plans />
              </Layout>
            </ProfileCompletionCheck>
          </ProtectedRoute>
        } 
      />

      {/* Fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
